<template lang='pug'>
  footer.app-footer.mt-4
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue